<script>
export default {
  methods: {
    intToString(number) {
      let result = "";
      number = number.toString()
      number = parseInt(number.replace(/,/g,""))
      if (number < 1000) {
        result = number
      }
      else if (number >= 1000000000) {
        result = (number / 1000000000).toFixed(1).toString().replace(".0","") + "B"
      }
      else if (number >= 1000000) {
        result = (number / 1000000).toFixed(1).toString().replace(".0","") + "M"
      }
      else {
        result = (number / 1000).toFixed(1).toString().replace(".0","") + "K"
      }
      return result
    }
  }
}
</script>